<template>
  <div class="employeeLIstVue">
    <div v-loading="loading" class="o-main-content-area">
        <!-- <div class="row c-responsive-fixwidth">
            <div class="col-md-3">
                <h1 class="h1">Resume User</h1>
            </div>
            <div class="col-md-9 text-right">
                <ul class="o-filter-area">

                    <li class="o-search-field">
                      

                        <div class="input-group stylish-input-group">
                            <input id="search-input-employee" type="text" class="form-control" placeholder="Search">
                            <span class="input-group-addon">
                                <button type="submit">
                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                            </button>
                            </span>
                        </div>

                    </li>
                    <li><a href="javascript: void(0)" class="c-common-btn c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> Add Resume User</a></li>

                    <li style="display: none;"><a href="javascript: void(0)" class="c-common-btn c-common-btn--inverse-icon-red"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete Employee</a></li>

                </ul>

            </div>
        </div> -->
        <!-- <iframe v-if="authUrl" :src="authUrl" class="resume-frame-window">
            <p>Your browser does not support iframes.</p>
        </iframe> -->
    </div>

    <!-- <div class="o-ndividualArea c-responsive-fixwidth">
        <div class="o-ndividualTable">

            <div class="o-skills-listing">
                <div class="row">
                    <div class="col col-sm-12">
                       <div class="o-scheduleTable--daily">
                            <div infinite-scroll-disabled="busy" infinite-scroll-distance="10" v-loading="loading">
                                <div class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employees-list-table-align employees-list-table">
                                        <div class="calls-table-row">
                                            <div class="calls-table-cell">
                                                <div class="o-right-side-padding5">
                                                    <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                        <div class="o-accordion-subtext user-icon o-list-user-img">
                                                            <div class="o-post-logged o-post-logged--table-user">
                                                                <div class="o-user-profile-img o-header-profile-pic">
                                                                    <div>
                                                                        <img  src="static/assets/images/user1.png" id='img-upload' />
                                                                    </div> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Name</span>
                                                            <div>Subhojit Das</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Email ID:</span>
                                                    <div>subhojitm@capitalnumbers.com</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Token</span>
                                                    <div>- - - - - - - -</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div  class="o-accordion-subtext o-rowtable-text">
                                                    <span>URL:</span>
                                                    <div >
                                                        <div>- - - - - - - -</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Cell:</span>
                                                    <div>
                                                        <div>7797904461</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="calls-table-cell">
                                            <div class="o-right-side-padding5">
                                                <div class="o-accordion-subtext o-rowtable-text o-notify-cell">
                                                    <span class="">Notify</span>
                                                    <div class="notify-icon">
                                                        <a href="javascript: void(0)"><i class="fa fa-mobile" aria-hidden="true"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell text-center o-no-padding">
                                            <div class="o-edit-trash o-no-padding">

                                                <div class="o-table-block-btn">
                                                    <a href="javascript: void(0)"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                                                </div>
                                                <div class="o-table-block-btn">
                                                    <a href="javascript: void(0)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                                </div>

                                            </div>
                                        </div>
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div> -->
   </div>
</template>
<script>
    import { mapGetters,  mapActions } from 'vuex';
    import dateTimeConvert from '../../timeConvert&Compare.js';;
    import service from '../../services.js';
    import {
        global
    } from '../../global.js';

    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: 'userClientID',
                employeeId : 'employeeId',
                userEmail: 'userEmail',
            }),
            
        },
        data() {
            return {
                authUrl:'',
                loading: true,
            }
        },
        methods: { 
            getAuthUrl() {
                this.$Progress.start();
                service.get('resume/getResumeUrl', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'email': this.userEmail
                }).
                then((res) => {
                    this.$Progress.finish();
                    if(res.data.result){
                        this.authUrl = res.data.result;
                        window.open(this.authUrl, '_blank');
                        this.$router.go(-1);
                    }
                    // console.log(res);
                }).catch((err) => {
                    // console.log(err);
                    this.$Progress.finish();
                });
            }
        },
        created() {
            this.getAuthUrl();
        },
        mounted(){
            setTimeout(()=>{
                $('#search-input-employee').focus();  
            },200);
        }
    }

</script>
<style>
.resume-frame-window{
    width: 100%;
    min-height: 768px;
}
</style>



// WEBPACK FOOTER //
// src/components/resume/resume.vue